import { Header } from "components/Header"
import { ExpenseForm } from "@src/components/expense-form"
import { ar } from "i18n/ar"

export default function NewExpense() {
  return (
    <>
      <Header title={ar.addExpense} />
      <ExpenseForm />
    </>
  )
}
